import React from 'react';
import CustomSpinner from '../CustomSpinner';
import { useGetPaymentMethods } from '../../hooks/usePayment';
import renderPaymentMethods from './renderPaymentMethods';
import { translate } from '../../helper';

export default function AllPaymentMethods({ textAlign = 'left', onEditCard = () => { }, useGrid = false }) {
    const { paymentMethods, isLoading } = useGetPaymentMethods();

    const bankMethods = (paymentMethods || []).filter(
        pm => (pm?.type || '').toLowerCase() === 'us_bank_account'
    );
    const cardMethods = (paymentMethods || []).filter(
        pm => (pm?.type || '').toLowerCase() === 'card'
    );
    const totalCards = (bankMethods.length + cardMethods.length);
    const gridStyle = {
        display: 'grid',
        gap: 'calc(var(--sp-md2)*2.2641509)',
        gridTemplateColumns:
            totalCards >= 3
                ? 'repeat(auto-fit, minmax(calc(var(--fs-hero)*8.01886), 1fr))'
                : 'repeat(auto-fill, minmax(calc(var(--fs-hero)*8), max-content))',
        width: '100%',
        alignItems: 'stretch',
    };
    const allPaymentStyle ={
        width: '100%', display: 'flex', flexDirection: 'column', gap: "calc(var(--sp-md2)*1.41509)", marginTop: "calc(var(--sp-lg)*1)"
    }

    return (
        <>
            {isLoading ? (
                <div style={{marginTop:'calc(var(--sp-lg)*1.5)'}}><CustomSpinner fullPage/></div>
            ) : (
                <>
                    {!paymentMethods || paymentMethods.length === 0 ? (
                        <div style={{ width: '100%', textAlign, padding: 'var(--sp-xl) 0', color: '#6B7280', fontSize: 'var(--fs-md2)' }}>
                            {translate("noPaymentMethodsFound")}
                        </div>
                    ) : (
                        <div style={useGrid ? gridStyle : allPaymentStyle}>
                            {renderPaymentMethods({ paymentMethods: bankMethods, type: 'us_bank_account', onEditCard })}
                            {renderPaymentMethods({ paymentMethods: cardMethods, type: 'card', onEditCard })}
                        </div>
                    )}
                </>
            )}
        </>
    );
};